/**
 * True when code is running inside the static prerender/SSG snapshot pass
 * (@prerenderer/renderer-puppeteer at build time), NOT in a real visitor's
 * browser.
 *
 * Two independent signals, either is sufficient:
 *  - window.__PRERENDER_INJECTED — set by the plugin via `inject:{prerender:true}`
 *    in vite.config.ts rendererOptions (deterministic build-time flag).
 *  - navigator.webdriver — headless Chrome (puppeteer) sets this to true;
 *    belt-and-suspenders in case the injected payload ever changes.
 *
 * Why it matters: posthog-js, when it initialises, injects its own bootstrap
 * <script> into the DOM. During prerender the plugin snapshots that DOM into
 * every static page, so the baked-in snippet re-runs `posthog.init(...)` on a
 * real visit with DEFAULT (cookie + localStorage) persistence + session
 * recording — writing to the device BEFORE consent and breaking the cookieless
 * TTDSG §25 / GDPR Art.6(1)(f) basis. Gating PostHog init and the consent banner
 * on `!isPrerender()` keeps that snippet out of the static HTML and stops the
 * build machine from emitting phantom pageviews.
 */
export function isPrerender(): boolean {
  if (typeof window === 'undefined') return true;
  const injected = (window as unknown as { __PRERENDER_INJECTED?: unknown }).__PRERENDER_INJECTED;
  const isWebdriver = typeof navigator !== 'undefined' && navigator.webdriver === true;
  return Boolean(injected) || isWebdriver;
}
